import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pb-3 px-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = {
  class: "py-2",
  valign: "top",
  width: "55"
}
const _hoisted_5 = {
  class: "py-2",
  valign: "top",
  width: "55"
}
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import ErrorComp from '@/components/Error.vue';
import Downloads from '@/components/Downloads.vue';
import ApiDownload from '@/components/ApiDownload.vue';
import {useStorage} from '@/composables/storage';
import useDetailDeliveryNoteStore from '@/store/detailDeliveryNote';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryNoteDetails',
  setup(__props, { expose: __expose }) {

const ddnStore = useDetailDeliveryNoteStore();
const {} = useStorage(ddnStore,
    (data) => data?.VerkauflieferscheinNr ? `Lieferschein ${data.VerkauflieferscheinNr}` : 'Lieferschein',
    (route) => {
      return {
        VerkauflieferscheinNr: parseInt(Array.isArray(route.params.delivery_note_id) ?
          route.params.delivery_note_id[0] :
          route.params.delivery_note_id),
      };
    });

__expose({
  Error: ErrorComp,
  Downloads: Downloads,
  ApiDownload,
  ddnStore,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(ddnStore).loading && !_unref(ddnStore).error && _unref(ddnStore).data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: _unref(ddnStore).data.color
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(ddnStore).data.icon), 1)
                    ], undefined, true),
                    _: 1
                  }, 8, ["color"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Status")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(ddnStore).data.status), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_v_list_item, null, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-calendar")
                    ], undefined, true),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Datum")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`${_unref(ddnStore).data.DatumFormatted} ${_unref(ddnStore).data.UhrZeit} Uhr`), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_v_list_item, null, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-account")
                    ], undefined, true),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Kunde")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(ddnStore).data.Kundname), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              (_unref(ddnStore).data.Lieferung.GeplantLieferdatum)
                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-timer")
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Geplantes Lieferdatum")
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(ddnStore).data.GeplantLieferdatumFormatted), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          }),
          (_unref(ddnStore).data.Archiv?.Values)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(ApiDownload, {
                  title: "Lieferschein herunterladen",
                  token: _unref(ddnStore).data.Archiv.Values[0].DownloadToken,
                  fileName: _unref(ddnStore).data.Archiv.Values[0].Dateiname
                }, null, 8, ["token", "fileName"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_3,
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ddnStore).data.Positionen, (position) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: position.PosNr
                  }, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(position.PosNr), 1),
                    _createElementVNode("td", _hoisted_5, [
                      _createTextVNode(_toDisplayString(position.Menge) + " ", 1),
                      _createElementVNode("small", null, _toDisplayString(position.Einheit), 1)
                    ]),
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("strong", null, _toDisplayString(position.ArtikelBezeichnung1), 1),
                      _hoisted_7,
                      (position.ArtikelBezeichnung2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(position.ArtikelBezeichnung2), 1),
                            _hoisted_9
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("em", null, "Art.-Nr.: " + _toDisplayString(position.ArtikelNr), 1)
                    ])
                  ]))
                }), 128))
              ])
            ], undefined, true),
            _: 1
          }),
          ((_unref(ddnStore).data.Dateien?.Values?.length ?? 0) > 0|| (_unref(ddnStore).data.Unterlagen?.Values.length ?? 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(Downloads, {
                  dateien: _unref(ddnStore).data.Dateien?.Values,
                  unterlagen: _unref(ddnStore).data.Unterlagen?.Values
                }, null, 8, ["dateien", "unterlagen"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_unref(ddnStore).error)
        ? (_openBlock(), _createBlock(_component_error, {
            key: 1,
            module: _unref(ddnStore).$id
          }, null, 8, ["module"]))
        : _createCommentVNode("", true)
  ]))
}
}

})